<section class="bg-(--color-secondary) pb-24">
  <div class="px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-6xl">
    <!-- content -->
    <div class="text-right ps-5 md:ps-10">
      <span
        class="inline-flex items-center px-13 py-2 rounded-lg bg-(--color-main-20) text-(--color-main) shadow-[0_4px_4px_rgba(0,0,0,0.25)] font-medium"
      >
        <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 4l6 6-6 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          /></svg
        >قصتنا
      </span>

      <h2 class="text-white text-4xl font-bold mt-4 leading-snug">من نحن؟</h2>

      <p class="about-text">
        في عام 2020، انطلقت أولاً <span class="awalan-text">(Awalan)</span>
        برؤية واضحة: أن نُعيد تعريف العلاقة بين المتعاقد المصري والقطاع الزراعي. لاحظنا أن هناك آلاف
        المشاريع الزراعية الواعدة التي تحتاج لتمويل، وفي المقابل آلاف المتعاقدين الذين يبحثون عن فرص
        حقيقية وشفافة لتنمية أموالهم. فكانت أولاً هي الجسر الذي يربط بينهما — منصة متكاملة تجمع
        التكنولوجيا بالخبرة الزراعية، وتطبّق أعلى معايير الحوكمة وإدارة المخاطر، لتوفر بيئة تعاقدية
        آمنة ومثمرة للجميع. اليوم، وبعد أكثر من 5 سنوات من العمل الجاد، نفخر بأننا نخدم أكثر من
        2000 متعاقد نشط، وقمنا بتمويل وتنفيذ أكثر من 85 مشروعاً زراعياً، وحققنا نسبة نجاح تتجاوز
        97%، وامتدت أعمالنا إلى أكثر من 800 ألف هكتار في مختلف محافظات مصر.
      </p>
    </div>

    <!-- image -->
    <div>
      <img
        src="/images/image-aboutus.jpeg"
        alt="AboutUs"
        class="w-full h-80 rounded-2xl shadow-[0_20px_40px_rgba(0,0,0,0.35)]"
      />
    </div>
  </div>
</section>
